import utils from "./utils";
import httpClient from "./network/httpClient";


const getParameterByName = function (url, name) {
  name = name.replace(/[[]/, "\\[").replace(/[\]]/, "\\]");
  const regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
    results = regex.exec(url);
  return results === null ? "" : results[1];
};


/**
 * updates the favicon based on the ${newUrl} provided
 * @param newUrl
 */
const updateFavicon = function (newUrl) {
  const favicon = document.getElementById("favicon");
  if (favicon) {
    favicon["href"] = newUrl;
  }
};

const updateHtmlLang = function (lang) {
  document.documentElement.setAttribute('lang',lang);
}

const cleanLocalStorage = function(){
  window.localStorage.removeItem("oneid_access_token");
  window.localStorage.removeItem("oneid_token_expiration_date");
  window.localStorage.removeItem("oneid_token_type");
  window.localStorage.removeItem("oneid_expires_in");
  window.localStorage.removeItem("oneid_state");
  window.localStorage.removeItem("oneid_state_check");
  window.localStorage.removeItem("oneid_section");
  window.localStorage.removeItem("oneid_id_token");
  window.localStorage.removeItem("oneid_refresh_token");
  window.localStorage.removeItem("oneid_code_verifier");
  window.localStorage.removeItem("oneid_reset_password_original_url");
}

const forceLogout = function (clientId, callback?){
  utils.showGlobalLoader();
  cleanLocalStorage();
  httpClient.sessionLogout(clientId).then((data: any) => {
    utils.hideGlobalLoader();
    callback && callback();
  })
  .catch((err) => {
    utils.hideGlobalLoader();
    callback && callback();
  });
  
};

const getWithExpiry = function (key) {
  const itemStr = localStorage.getItem(key)
  // if the item doesn't exist, return null
  if (!itemStr) {
    return null
  }
  const item = JSON.parse(itemStr)
  const now = new Date()
  // compare the expiry time of the item with the current time
  if (now.getTime() > item.expiry) {
    // If the item is expired, delete the item from storage
    // and return null
    localStorage.removeItem(key)
    return null
  }
  return item.value
};

const setWithExpiry = function(key, value, ttl) {
  const now = new Date()

  // `item` is an object which contains the original value
  // as well as the time when it's supposed to expire
  const item = {
    value: value,
    expiry: now.getTime() + ttl,
  }
  localStorage.setItem(key, JSON.stringify(item))
};

const forceLogoutFromLogout = function (clientId, callback, internalClientId){
  console.log('before logout - to clear local storage ');

  utils.showGlobalLoader();
  cleanLocalStorage();
  
  console.log('before logout - localstorage cleared ');

  if(clientId){
    console.log('session logout with clientId: ',clientId);
    httpClient.sessionLogout(clientId).then((data: any) => {
      utils.hideGlobalLoader();
      callback && callback();
    })
    .catch((err) => {
      utils.hideGlobalLoader();
      callback && callback();
    });
  }else if(!clientId){
    console.log('session logout with internalClientId: ',internalClientId);

    httpClient.sessionLogout(internalClientId).then((data: any) => {
      utils.hideGlobalLoader();
      callback && callback();
    })
    .catch((err) => {
      utils.hideGlobalLoader();
      callback && callback();
    });
  }else{

    // clientId && !isCloudEnabled
    //is a legacy client
    utils.hideGlobalLoader();
    callback && callback();
    console.log('[sessionUtils] clientId: '+clientId+' is a legacy client and no session/revoke invoked');
  }
};




export default {
  getWithExpiry,
  setWithExpiry,
  updateHtmlLang,
  forceLogout,
  forceLogoutFromLogout,
  getParameterByName,
  updateFavicon,
  cleanLocalStorage,
};
